'use es6';
/**
 * @typedef {Object} SentryMessages
 * @property {String} LAYOUT_INVALID_SECTION_DELIMITERS - Occurs when a layout has invalid section delimiters.
 */

/**
 * Messages to be used with Raven client.
 *
 * @enum {String}
 * @readonly
 */

export const LOCAL_STORAGE_LEGACY_KEY_ENCOUNTERED = 'LOCAL_STORAGE_LEGACY_KEY_ENCOUNTERED';